import { ButtonLink } from '../../../components/Form/Button';
import { useTranslation } from '../../../i18n/i18n';
import { CmsGrid } from '../CmsGrid/CmsGrid';
import './CmsProductImageGrid.css';

type CmsProductImageGridProps = {
	images: { src: string }[];
	campaignLink: string;
};

export const CmsProductImageGrid = ({ images, campaignLink }: CmsProductImageGridProps): JSX.Element => {
	const t = useTranslation().myPages;
	return (
		<div className="cms-product-image-grid">
			<CmsGrid size={'2-mobile'}>
				{images.map((i, index) => (
					<div key={index} className="image-container">
						{' '}
						<img src={i.src} alt="product image" />{' '}
					</div>
				))}
			</CmsGrid>
			<ButtonLink linkTo={campaignLink}>{t.goToCampaign}</ButtonLink>
		</div>
	);
};
